/* QABAS — Thème Signature */
(function () {
  'use strict';
  var Q = window.QABAS || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var money = function (cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  };
  var lenis = null;

  /* ---------- Loader ---------- */
  function initLoader() {
    var loader = $('[data-loader]');
    if (!loader) return;
    var seen = false;
    try { seen = sessionStorage.getItem('qabas-loader') === '1'; } catch (e) {}
    if (seen || reduced) { loader.classList.add('is-skip'); document.dispatchEvent(new Event('qabas:ready')); return; }
    var done = function () {
      loader.classList.add('is-done');
      try { sessionStorage.setItem('qabas-loader', '1'); } catch (e) {}
      setTimeout(function () { document.dispatchEvent(new Event('qabas:ready')); }, 350);
      setTimeout(function () { loader.classList.add('is-skip'); }, 1200);
    };
    var start = Date.now();
    var finish = function () { setTimeout(done, Math.max(0, 1400 - (Date.now() - start))); };
    if (document.readyState === 'complete') finish(); else window.addEventListener('load', finish);
    setTimeout(done, 3500);
  }

  /* ---------- Smooth scroll ---------- */
  function initLenis() {
    if (!Q.settings || !Q.settings.smooth || Q.designMode || reduced || typeof window.Lenis === 'undefined') return;
    lenis = new window.Lenis({ duration: 1.15, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, smoothWheel: true });
    function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var t = document.getElementById(id.slice(1));
      if (t) { e.preventDefault(); lenis.scrollTo(t, { offset: -60 }); }
    });
  }
  function lockScroll(on) {
    document.body.classList.toggle('is-locked', on);
    if (lenis) { on ? lenis.stop() : lenis.start(); }
  }

  /* ---------- Split text ---------- */
  function splitText(el) {
    if (el.dataset.splitDone) return;
    el.dataset.splitDone = '1';
    var wi = 0;
    var walk = function (node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var parts = child.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'w';
            var i = document.createElement('span'); i.textContent = p; i.style.setProperty('--wi', wi++);
            w.appendChild(i); frag.appendChild(w);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') { walk(child); }
      });
    };
    walk(el);
  }

  /* ---------- Reveal ---------- */
  var io = null;
  function initReveal(scope) {
    var els = $$('[data-reveal], [data-split], [data-footer-giant]', scope);
    $$('[data-split]', scope).forEach(splitText);
    if (Q.designMode || reduced || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Highlight words on scroll ---------- */
  var highlights = [];
  function initHighlight(scope) {
    $$('[data-highlight]', scope).forEach(function (el) {
      if (!el.dataset.hlDone) {
        el.dataset.hlDone = '1';
        el.innerHTML = el.textContent.trim().split(/\s+/).map(function (w) { return '<span class="hw">' + w.replace(/</g, '&lt;') + '</span>'; }).join(' ');
      }
      highlights.push({ el: el, words: $$('.hw', el) });
    });
  }
  function updateHighlight() {
    var vh = window.innerHeight;
    highlights.forEach(function (h) {
      var r = h.el.getBoundingClientRect();
      var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      p = Math.max(0, Math.min(1, p));
      var n = Math.round(p * h.words.length);
      h.words.forEach(function (w, i) { w.classList.toggle('is-lit', i < n || Q.designMode); });
    });
  }

  /* ---------- Parallax ---------- */
  var parallax = [];
  function initParallax(scope) {
    if (reduced) return;
    $$('[data-parallax]', scope).forEach(function (el) { parallax.push({ el: el, s: parseFloat(el.dataset.parallax) || 0.1 }); });
  }
  function updateParallax() {
    var vh = window.innerHeight;
    parallax.forEach(function (p) {
      var r = p.el.parentElement.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var c = (r.top + r.height / 2) - vh / 2;
      p.el.style.transform = 'translate3d(0,' + (-c * p.s).toFixed(1) + 'px,0)';
    });
  }

  /* ---------- Header ---------- */
  var header, headerWrap, lastY = 0;
  function initHeader() {
    header = $('[data-header]');
    if (!header) return;
    headerWrap = header.closest('.shopify-section') || header;
    var firstHero = $('main > .shopify-section:first-child .hero');
    if (header.classList.contains('header--transparent') && !firstHero) header.classList.add('is-solid', 'is-forced');
    var s = $('[data-search]');
    $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { if (!s) return; e.preventDefault(); s.classList.toggle('is-open'); header.classList.add('is-solid'); if (s.classList.contains('is-open')) setTimeout(function () { var i = $('input[type=search]', s); i && i.focus(); }, 300); }); });
    $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { s.classList.remove('is-open'); onScroll(); }); });
    var menu = $('[data-menu]');
    $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { menu.classList.add('is-open'); lockScroll(true); }); });
    $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { menu.classList.remove('is-open'); lockScroll(false); }); });
  }
  function onScroll() {
    var y = window.scrollY;
    if (header) {
      var search = $('[data-search]');
      var searchOpen = search && search.classList.contains('is-open');
      if (header.classList.contains('header--transparent') && !header.classList.contains('is-forced')) header.classList.toggle('is-solid', y > 40 || searchOpen);
      if (headerWrap && !searchOpen) headerWrap.classList.toggle('is-hidden', y > lastY && y > 300);
    }
    lastY = y;
    updateParallax();
    updateHighlight();
  }

  /* ---------- Cursor ---------- */
  function initCursor() {
    var c = $('[data-cursor]');
    if (!c || !fine || reduced) { if (c) c.remove(); return; }
    var dot = $('.cursor__dot', c), ring = $('.cursor__ring', c), label = $('[data-cursor-label]', c);
    var mx = -100, my = -100, rx = -100, ry = -100;
    window.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; dot.style.transform = 'translate(' + mx + 'px,' + my + 'px) translate(-50%,-50%)'; }, { passive: true });
    (function loop() { rx += (mx - rx) * 0.16; ry += (my - ry) * 0.16; ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)'; requestAnimationFrame(loop); })();
    document.addEventListener('mouseover', function (e) {
      var t = e.target.closest('[data-cursor-text]');
      if (t) { label.textContent = t.dataset.cursorText; c.classList.add('is-label'); c.classList.remove('is-hover'); return; }
      c.classList.remove('is-label');
      c.classList.toggle('is-hover', !!e.target.closest('a, button, label, summary, input, select'));
    });
    document.addEventListener('mouseleave', function () { mx = my = -100; });
  }

  /* ---------- Magnetic ---------- */
  function initMagnetic(scope) {
    if (!fine || reduced) return;
    $$('[data-magnetic]', scope).forEach(function (el) {
      if (el.dataset.magDone) return; el.dataset.magDone = '1';
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2, y = e.clientY - r.top - r.height / 2;
        el.style.transform = 'translate(' + x * 0.22 + 'px,' + y * 0.3 + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Drag sliders ---------- */
  function initDrag(scope) {
    $$('[data-drag]', scope).forEach(function (el) {
      if (el.dataset.dragDone) return; el.dataset.dragDone = '1';
      var down = false, sx = 0, sl = 0, moved = false;
      el.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = el.scrollLeft; });
      window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; el.classList.add('is-dragging'); } el.scrollLeft = sl - dx; });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { el.classList.remove('is-dragging'); }, 50); });
      el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---------- Accordions (smooth) ---------- */
  function initAccordions(scope) {
    $$('details.acc', scope).forEach(function (d) {
      if (d.dataset.accDone) return; d.dataset.accDone = '1';
      var sum = $('summary', d), body = $('.acc__body', d);
      if (!sum || !body || reduced) return;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          var h = body.scrollHeight;
          body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 400, easing: 'cubic-bezier(.2,.8,.2,1)' }).onfinish = function () { d.open = false; };
        } else {
          d.open = true;
          var h2 = body.scrollHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 500, easing: 'cubic-bezier(.2,.8,.2,1)' });
        }
      });
    });
  }

  /* ---------- Cart ---------- */
  var drawer, overlay;
  function openCart() {
    drawer = $('[data-cart-drawer]'); overlay = $('[data-overlay]');
    if (!drawer) { window.location.href = Q.routes.cart; return; }
    drawer.classList.add('is-open'); overlay && overlay.classList.add('is-active'); lockScroll(true);
  }
  function closeCart() {
    drawer = $('[data-cart-drawer]'); overlay = $('[data-overlay]');
    drawer && drawer.classList.remove('is-open'); overlay && overlay.classList.remove('is-active'); lockScroll(false);
  }
  function renderCart(html) {
    var sectionEl = document.getElementById('shopify-section-cart-drawer');
    if (!sectionEl || !html) return;
    var wasOpen = $('[data-cart-drawer]') && $('[data-cart-drawer]').classList.contains('is-open');
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-cart-drawer]');
    if (!fresh) return;
    if (wasOpen) fresh.classList.add('is-open');
    var old = $('[data-cart-drawer]');
    old.parentNode.replaceChild(fresh, old);
    updateCount(parseInt(fresh.dataset.count || '0', 10));
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (b) {
      b.textContent = n; b.classList.toggle('is-empty', n === 0);
      b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump');
    });
  }
  function fetchJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function initCart() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
      if (e.target.closest('[data-cart-close]') || e.target.closest('[data-overlay]')) {
        closeCart();
        var m = $('[data-menu]'); if (m && m.classList.contains('is-open')) { m.classList.remove('is-open'); lockScroll(false); }
        return;
      }
      var ch = e.target.closest('[data-line-change]');
      if (ch) {
        e.preventDefault();
        var line = ch.closest('[data-key]');
        var d = $('[data-cart-drawer]'); d && d.classList.add('is-loading');
        fetchJSON(Q.routes.cartChange, { id: line.dataset.key, quantity: parseInt(ch.dataset.lineChange, 10), sections: ['cart-drawer'] })
          .then(function (res) { renderCart(res.sections && res.sections['cart-drawer']); })
          .catch(function (err) { alert((err && (err.description || err.message)) || 'Erreur'); })
          .finally(function () { var d2 = $('[data-cart-drawer]'); d2 && d2.classList.remove('is-loading'); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ajax-cart]');
      if (!form || !document.getElementById('shopify-section-cart-drawer')) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var err = form.querySelector('[data-buy-error]');
      if (btn) btn.classList.add('is-loading');
      if (err) err.hidden = true;
      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);
      fetch(Q.routes.cartAdd, { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
        .then(function (res) { renderCart(res.sections && res.sections['cart-drawer']); openCart(); })
        .catch(function (j) {
          var msg = (j && (j.description || j.message)) || 'Impossible d\'ajouter ce produit.';
          if (err) { err.textContent = msg; err.hidden = false; } else { alert(msg); }
        })
        .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    });
  }

  /* ---------- Product (variants, qty, sticky) ---------- */
  function initProduct(scope) {
    $$('[data-product-buy]', scope).forEach(function (box) {
      if (box.dataset.pDone) return; box.dataset.pDone = '1';
      var pj = $('[data-product-json]', box), sj = $('[data-stock-json]', box);
      if (!pj) return;
      var product = JSON.parse(pj.textContent);
      var stock = {}; try { stock = JSON.parse(sj.textContent); } catch (e) {}
      var section = box.closest('.shopify-section') || document;
      var idInput = $('[data-variant-id]', box);
      var atc = $('[data-atc]', box), atcText = $('[data-atc-text]', box), atcPrice = $('[data-atc-price]', box);
      var threshold = parseInt(document.documentElement.dataset.lowStock || '5', 10);
      var stockText = $('[data-stock-text]', box), stockDot = $('.stock__dot', box);

      var update = function () {
        var sel = $$('fieldset.opt', box).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        $$('fieldset.opt', box).forEach(function (fs, i) { var out = $('[data-option-value]', fs); if (out) out.textContent = sel[i]; });
        // unavailable marks
        $$('fieldset.opt', box).forEach(function (fs, idx) {
          $$('input', fs).forEach(function (inp) {
            var test = sel.slice(); test[idx] = inp.value;
            var ok = product.variants.some(function (x) { return x.available && x.options.every(function (o, i) { return o === test[i]; }); });
            var lab = fs.querySelector('label[for="' + inp.id + '"]'); if (lab) lab.classList.toggle('is-unavailable', !ok);
          });
        });
        if (!v) { if (atc) { atc.disabled = true; atcText.textContent = 'Indisponible'; atcPrice.textContent = ''; } return; }
        idInput.value = v.id;
        if (atc) { atc.disabled = !v.available; atcText.textContent = v.available ? 'Ajouter au panier' : 'Épuisé'; atcPrice.textContent = v.available ? money(v.price) : ''; }
        var cur = $('[data-price-current]', section), cmp = $('[data-price-compare]', section), badge = $('[data-price-badge]', section), sp = $('[data-sticky-price]', section);
        if (cur) { cur.textContent = money(v.price); cur.classList.toggle('price--sale', v.compare_at_price > v.price); }
        if (sp) sp.textContent = money(v.price);
        if (cmp) { cmp.hidden = !(v.compare_at_price > v.price); cmp.textContent = v.compare_at_price ? money(v.compare_at_price) : ''; }
        if (badge) { var on = v.compare_at_price > v.price; badge.hidden = !on; if (on) badge.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
        if (stockText) {
          var s = stock[v.id] || {};
          stockDot.className = 'stock__dot';
          if (!v.available) { stockDot.classList.add('stock__dot--out'); stockText.textContent = 'Épuisé — reviens vite pour le prochain drop'; }
          else if (s.m && s.q > 0 && s.q <= threshold) { stockDot.classList.add('stock__dot--low'); stockText.textContent = 'Plus que ' + s.q + ' en stock'; }
          else { stockText.textContent = box.dataset.stockDefault || 'En stock'; }
        }
        if (v.featured_media) {
          var m = section.querySelector('[data-media-id="' + v.featured_media.id + '"]');
          if (m) {
            var track = m.parentElement;
            if (window.innerWidth < 990) track.scrollTo({ left: m.offsetLeft, behavior: 'smooth' });
            else if (m !== track.firstElementChild) { track.insertBefore(m, track.firstElementChild); }
          }
        }
        if (box.closest('[data-pdp]') && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      };
      box.addEventListener('change', function (e) { if (e.target.classList.contains('opt__input')) update(); });
      $$('[data-qty]', box).forEach(function (b) {
        b.addEventListener('click', function () { var i = $('.qty__input', box); i.value = Math.max(1, (parseInt(i.value, 10) || 1) + parseInt(b.dataset.qty, 10)); });
      });
      if (product.variants.length > 1) update();
    });

    // Gallery dots (mobile)
    $$('[data-gallery]', scope).forEach(function (g) {
      var track = $('.pdp__track', g), dots = $$('.pdp__dots span', g);
      if (!track || !dots.length) return;
      track.addEventListener('scroll', function () { var i = Math.round(track.scrollLeft / track.clientWidth); dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); }, { passive: true });
    });

    // Sticky ATC
    $$('[data-sticky-atc]', scope).forEach(function (bar) {
      var section = bar.closest('[data-pdp]');
      var main = section && $('[data-atc]', section);
      if (!main || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (en) { bar.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(main);
      $('[data-sticky-trigger]', bar).addEventListener('click', function () { main.click(); });
    });
  }

  /* ---------- Recommendations ---------- */
  function initRecos(scope) {
    $$('[data-recos]', scope).forEach(function (el) {
      if (el.dataset.loaded) return; el.dataset.loaded = '1';
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recos]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initAll(el); }
      }).catch(function () {});
    });
  }

  /* ---------- Collection filters ---------- */
  function initFilters(scope) {
    $$('[data-filter-form]', scope).forEach(function (f) {
      if (f.dataset.fDone) return; f.dataset.fDone = '1';
      f.addEventListener('change', function () {
        var params = new URLSearchParams(new FormData(f));
        Array.from(params.keys()).forEach(function (k) { if (!params.get(k)) params.delete(k); });
        window.location.search = params.toString();
      });
    });
  }

  /* ---------- Init ---------- */
  function initAll(scope) {
    initReveal(scope); initHighlight(scope); initParallax(scope); initMagnetic(scope);
    initDrag(scope); initAccordions(scope); initProduct(scope); initRecos(scope); initFilters(scope);
    updateParallax(); updateHighlight();
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (Q.designMode) document.documentElement.classList.add('shopify-design-mode');
    initLoader(); initLenis(); initHeader(); initCursor(); initCart();
    var loaderEl = $('[data-loader]');
    var boot = function () { initAll(document); };
    if (loaderEl && !loaderEl.classList.contains('is-skip')) document.addEventListener('qabas:ready', boot, { once: true }); else boot();
    var ticking = false;
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { onScroll(); ticking = false; }); } }, { passive: true });
    window.addEventListener('resize', function () { updateParallax(); }, { passive: true });
    onScroll();
  });

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); if (e.target.querySelector('[data-header]')) initHeader(); });
  document.addEventListener('shopify:section:select', function (e) { if (e.target.id === 'shopify-section-cart-drawer') openCart(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.target.id === 'shopify-section-cart-drawer') closeCart(); });
})();
